<script setup>
defineProps({
    value: String,
    classes: String,
})
</script>

<template>
    <p :class="classes + ' mt-4 text-xl text-gray-400'">
        <template v-if="value">{{ value }}</template>
        <template v-else><slot /></template>
    </p>
</template>
